<template>
    <div class="rounded-lg2 border border-slate-200 p-3">
        <div class="text-base font-bold text-slate-900">
            {{ title }}
        </div>
        <div class="mt-1 flex items-center gap-3 text-xs text-slate-600">
            <span class="inline-flex items-center gap-1">
                <LandingPageIcon
                    name="clock"
                    class="h-3.5 w-3.5"
                />
                {{ duration }} mins
            </span>
            <span
                v-if="isRecurring"
                class="inline-flex items-center gap-1"
            >
                <LandingPageIcon
                    name="recurring"
                    class="h-3.5 w-3.5"
                />
                Recurring
            </span>
        </div>
        <p class="mt-1.5 text-xs text-slate-600">
            {{ description }}
        </p>
    </div>
</template>

<script setup lang="ts">
    import LandingPageIcon from '@/Marketing/LandingPage/Component/LandingPageIcon.vue'

    const props = defineProps({
        title: {
            type: String,
            required: true,
        },
        description: {
            type: String,
            required: true,
        },
        duration: {
            type: Number,
            required: true,
        },
        isRecurring: {
            type: Boolean,
            default: false,
        },
    })
</script>
